import actions from "./actions";

const makeTipPayment = actions.makeTipPayment;

export default {
  makeTipPayment,
};
